// SPDX-License-Identifier: MIT
// Export control selectors: restriction driven solely by the global Azure provider
// data loaded flag (ADR-004). Historical per-dataset provenance system was removed.
import { RootState } from '../store';
import { selectAzureProviderDataLoaded } from '../cloud-providers/azure/azure-slice';

export const selectHasSecureDatasets = (state: RootState): boolean =>
  selectAzureProviderDataLoaded(state);
export const isExportRestricted = selectHasSecureDatasets; // maintained alias
